import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ContentService } from "../../../services/content.service";
import { forkJoin, catchError, of } from "rxjs";
import { Tab } from "../../../models/tabs.model";
import { AuthService } from "../../../services/auth.service";
import { NavigationService } from "../../../services/navigation.service";

@Component({
  selector: "app-donor",
  templateUrl: "./donor.component.html",
  styleUrl: "./donor.component.scss",
})
export class DonorComponent implements OnInit {
  isLoading = false;
  userId: string | null = null;
  currentUrl = "";
  profileInfo: any;

  contract: any;
  downloadingConsent = false;
  contractStatus = "";

  dashboardTabs: Tab[] = [
      { text: "Synopsis", name: "synopsis" },
      { text: "Journey", name: "journey" },
      { text: "MRB", name: "mrb" },

    ];
  

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private contentService: ContentService,
    private authService: AuthService,
    private navigationService: NavigationService
  ) {}

  ngOnInit(): void {
    this.userId = this.route.snapshot.paramMap.get("userId");
    this.currentUrl = this.router.url;


    if (this.userId) {
      this.isLoading = true;
      // Get Donor Info for table
      forkJoin([
        this.contentService.getDonorAndRecipientProfileInfo(this.userId).pipe(
          catchError((error) => {
            console.error("Error fetching profile info:", error);
            return of(null); // Return null or empty object if the profile info fails
          })
        ),
        this.contentService.getContractForAdminByUserId(this.userId).pipe(
          catchError((error) => {
            if (error.status === 404) {
             
            } else {
              console.error("Error fetching profile info:", error);
            }

            return of(null); // Return null or empty object if the profile info fails
          })
        ),
      ]).subscribe({
        next: ([profileInfo, contract]) => {
          // Handle the combined results
          this.profileInfo = profileInfo?.data; // Assign profile info to a variable
          if (contract) {
            this.contract = contract;
            this.contractStatus = contract.status;
          }

          this.isLoading = false; // Optional: Hide the loading indicator
        },
        error: (err) => {
          console.error("Error fetching data:", err);

          this.isLoading = false; // Optional: Hide the loading indicator even if there's an error
        },
      });
      // Get Donor Journey sections by user id
    }
  }

  viewMRBReport() {
    this.router.navigate([`/hospital/donor/${this.userId}/mrb`]);
  }

  getConsentStatusClass(status: string | null): string {
    if (!status) return "status-not-sent";

    const statusMapping: Record<string, string> = {
      "Consent Sent": "status-sent",
      "Consent Viewed": "status-viewed",
      "Consent Signed": "status-signed",
      "Consent Declined": "status-declined",
    };

    return statusMapping[status] || "status-not-sent";
  }

  generateDownloadUrl() {
    if (this.contract) {
      this.downloadingConsent = true;
      const fileName: string = this.contract?.contract_filename ?? "";

      this.contentService.generateDownloadUrl(fileName, "contracts").subscribe({
        next: ({ downloadUrl }) => {
          window.open(downloadUrl, "_blank");
          this.downloadingConsent = false;
        },
        error: (err) => {
          console.error("Error generating download URL:", err);
          this.downloadingConsent = false;
        },
      });
    }
  }

  onTabChange(selectedTab: string) {
    const routeSegment = selectedTab.toLowerCase();

    this.router.navigate([`/hospital/donor/${this.userId}/${routeSegment}`]); // Update hash in URL
  }

  goBack(): void {
    this.navigationService.goBack();
  }
}
